import { render } from "./VideoOverlay.vue?vue&type=template&id=4002202b"
import script from "./VideoOverlay.vue?vue&type=script&lang=js"
export * from "./VideoOverlay.vue?vue&type=script&lang=js"

import "./VideoOverlay.vue?vue&type=style&index=0&id=4002202b&lang=scss"
script.render = render

export default script